import { HEADERS_BLOCKLIST } from '../constants';

const SENSITIVE_HEADERS_SET = new Set(HEADERS_BLOCKLIST);

/**
 * Filters out sensitive headers based on HEADERS_BLOCKLIST
 * @param rawHeaders - Raw request headers from req.headers
 * @returns Filtered headers object with sensitive headers removed
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const filterSensitiveHeaders = (rawHeaders: any): any => {
  if (!rawHeaders || typeof rawHeaders !== 'object') {
    return {};
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const filteredHeaders: any = {};

  for (const [key, value] of Object.entries(rawHeaders)) {
    if (!SENSITIVE_HEADERS_SET.has(key.toLowerCase()) && value != null) {
      filteredHeaders[key] = value;
    }
  }

  return filteredHeaders;
};
